import { useState } from 'react';

import { useHandlePaymentMethod } from '../hooks/useHandlePaymentMethod';

import icCard from '@/assets/myAccount/ic_creditcard.png';
import icLink from '@/assets/myAccount/ic_linkpagos.png';
import icCuentas from '@/assets/myAccount/ic_pagomiscuentas.png';
import { Button, Tags } from '@/components';
import { TipoProductoTO } from '@/types/myAccount';
import {
  cn,
  PAYMENT_METHODS,
  PAYMENT_METHODS_BY_ID,
  PaymentMethod,
} from '@/utils';

export const PaymentMethodSelector = ({
  product,
  amountToWallet,
}: {
  product?: TipoProductoTO;
  amountToWallet?: number;
}) => {
  const [selected, setSelected] = useState<PaymentMethod | null>();
  const { handlePaymentMethod } = useHandlePaymentMethod();

  const classButtonTag =
    'lg:flex w-full text-left lg:justify-center h-[46px] text-sm lg:text-gdt-blue text-gdt-gray-2 border-gdt-gray-xl2 flex items-center p-0';

  const handleIsChecked = (methodSelected: number) => {
    return selected?.id === methodSelected;
  };

  return (
    <div className="p-6 flex flex-col justify-around flex-1 lg:p-0 mt-2">
      <strong className="text-sm text-gdt-gray lg:text-center lg:font-semibold">
        Seleccioná el método de pago
      </strong>
      <div className="flex-1">
        <ul className="space-y-4 lg:space-y-2 mt-5">
          <li>
            <Tags.Checkbox
              className={classButtonTag}
              id={PAYMENT_METHODS.DEB_CRED.id}
              isChecked={handleIsChecked(PAYMENT_METHODS.DEB_CRED.id)}
              onClick={(e) =>
                setSelected((e && PAYMENT_METHODS_BY_ID[e]) || null)
              }
            >
              <figure className="w-14 lg:-ml-7 flex justify-center">
                <img src={icCard} width={21} />
              </figure>
              <span>Tarjeta de crédito o débito</span>
            </Tags.Checkbox>
          </li>
          <li>
            <Tags.Checkbox
              className={classButtonTag}
              id={PAYMENT_METHODS.PAGO_MIS_CUENTAS.id}
              isChecked={handleIsChecked(PAYMENT_METHODS.PAGO_MIS_CUENTAS.id)}
              onClick={(e) =>
                setSelected((e && PAYMENT_METHODS_BY_ID[e]) || null)
              }
            >
              <figure className="w-14 lg:-ml-7 flex justify-center">
                <img src={icCuentas} width={33} />
              </figure>
              <span>Pago Mis Cuentas</span>
            </Tags.Checkbox>
          </li>
          <li>
            <Tags.Checkbox
              className={classButtonTag}
              id={PAYMENT_METHODS.LINK_PAGOS.id}
              isChecked={handleIsChecked(PAYMENT_METHODS.LINK_PAGOS.id)}
              onClick={(e) =>
                setSelected((e && PAYMENT_METHODS_BY_ID[e]) || null)
              }
            >
              <figure className="w-14 lg:-ml-7 flex justify-center">
                <img src={icLink} width={25} />
              </figure>
              <span>Link Pagos</span>
            </Tags.Checkbox>
          </li>
          <li>
            <Tags.Checkbox
              disabled
              className={cn(`${classButtonTag} flex items-center`)}
              id={PAYMENT_METHODS.PAGO_FACIL.id}
              isChecked={handleIsChecked(PAYMENT_METHODS.PAGO_FACIL.id)}
              onClick={(e) =>
                setSelected((e && PAYMENT_METHODS_BY_ID[e]) || null)
              }
            >
              <span className="font-normal p-2 flex-1 inline-block mr-10 lg:text-end lg:p-0 text-left">
                Pago Fácil / Rapipago / Cobro Express
              </span>

              <span className="w-[100px] mr-2 rounded-full bg-[#e4e4e4] px-[8px] py-[2px] text-[11px] font-bold leading-[16px] text-[#5f5f5f] whitespace-nowrap">
                No disponible
              </span>
            </Tags.Checkbox>
          </li>
        </ul>
      </div>
      <div className="">
        <Button
          className="w-full lg:mt-5"
          disabled={!selected}
          type="button"
          variant="primary"
          onClick={() => {
            handlePaymentMethod({
              product,
              moneyToWallet: amountToWallet,
              paymentMethod:
                selected && selected.id && PAYMENT_METHODS_BY_ID[selected?.id],
            });
          }}
        >
          Continuar
        </Button>
      </div>
    </div>
  );
};
